import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { IconList } from '@hivebrite/design-system/Icon';

import EmptyState from 'hb-builder/components/common/state/EmptyState';
import { useBuilderConfigContext } from 'hb-builder/contexts/BuilderConfigContext';

const EmptyDynamicComponent = ({ dataTestId }: { dataTestId?: string }) => {
  const {
    hivebrite: { networkColors },
  } = useBuilderConfigContext();

  return (
    <EmptyState
      bg={networkColors?.fo_background_color}
      color="inherit"
      height="300px"
      dataTestId={dataTestId}
    >
      <Wrapper>
        <IconWrapper color={networkColors?.button_primary}>
          <IconList size={80} />
        </IconWrapper>
        <Box color="inherit">
          {s__('Builder|Data selection needed from the panel')}
        </Box>
      </Wrapper>
    </EmptyState>
  );
};

export default EmptyDynamicComponent;

const Wrapper = styled(Box).attrs(() => ({
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
  width: '100%',
}))``;

const IconWrapper = styled.span`
  color: ${({ color }) => color};
`;
